var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ukeyGuide"},[_c('pdfPreview',{attrs:{"url":_vm.PDFData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }